import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { WindowRef } from '../../../util/window.ref';

@Injectable({
  providedIn: 'root'
})
export class QueryParamService {

  constructor(
    private route: ActivatedRoute
  ) {
  }

  /**
   * Get the value of query param. If there are multiple params, this return the first result
   *
   * @param param
   */
  get(param: string): string {
    return this.route.snapshot.queryParamMap.get(param);
  }

  /**
   * Get value of query param from given route snapshot. Returns null if it doesn't exist
   *
   * @param snapshot
   * @param param
   */
  getFromSnapshot(snapshot: ActivatedRouteSnapshot, param: string): string {
    return snapshot.queryParams[param] ? snapshot.queryParams[param] : null;
  }

  /**
   * Get all occurrences of query param.
   *
   * @param param
   */
  getAll(param: any): string[] {
    return this.route.snapshot.queryParamMap.getAll(param);
  }

  /**
   * Get the value of a query string.
   *
   * The query param is pulled form the location.href because ActivatedRoute doesn't solve the
   * params and query params until AFTER the component is rendered so they are not available during the interceptor chain.
   *
   * @param name
   * @param url
   */
  getFromWindowRef(name: string, url?: string): string | null {
    if (!name) return null;
    const href = url || WindowRef.nativeWindow.location.href;
    const paramRegex = new RegExp('[?&]' + name + '=([^&#]*)', 'i');
    const param = paramRegex.exec(href);
    return param ? param[1] : null;
  }
}
